var React = require('react');

function Eclipse (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M295.2 377.2c-44.2 14.3-94.6 4.4-129.7-30.7a128.13 128.13 0 0 1 0-181c35.1-35.1 85.5-45 129.8-30.7a203.26 203.26 0 0 1 25.1-28.9L271.5 9.6a17.31 17.31 0 0 0-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4a17.31 17.31 0 0 0 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7a17.31 17.31 0 0 0 31 0l47.3-94.7 5.3 1.8a205.94 205.94 0 0 1-28.8-32.3zM256 160a96 96 0 1 0 22.3 189.1 205.49 205.49 0 0 1 0-186.2A96.63 96.63 0 0 0 256 160z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M640 256A176 176 0 1 1 464 80a176 176 0 0 1 176 176z","className":"fa-primary","key":2})]);
}

Eclipse.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Eclipse;

Eclipse.default = Eclipse;
